var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"6"}},[_c('div',{staticClass:"card-title mb-3"},[_vm._v(" "+_vm._s(_vm.$t("role.logistics.Connections.Delivery.title"))+" ")])])],1),(_vm.connectionData && _vm.connectionData.length > 0)?_c('CRow',{staticClass:"p-3"},[_c('Header',{attrs:{"data":[
        _vm.$t('models.logistics.connections.market'),
        _vm.$t('models.logistics.connections.country'),
        _vm.$t('models.logistics.connections.phone'),
        'URL',
        _vm.$t('models.logistics.connections.contacts'),
        _vm.$t('models.logistics.connections.serviceZone') ]}}),_vm._l((_vm.connectionData),function(item,index){return _c('Row',{key:index,attrs:{"data":[
        {
          data: _vm.marketName(item.market.role.name, item.market.role.id),
          type: 'html',
        },
        { data: item.market.role.country, type: 'text' },
        { data: item.market.role.tel, type: 'text' },
        { data: item.market.role.url, type: 'text' },
        { data: item.market.role.info_contact, type: 'text' },
        { data: item.market.role.desc_zone, type: 'text' } ],"border":true,"topAligned":true}})})],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }